export const mockPosts = [
  {
    id: 1,
    title: "2025赛季NBA总冠军预测：湖人能否夺冠？",
    summary: "随着詹姆斯状态回勇，东契奇与湖人众将配合更进一步，湖人在西部的竞争力大幅提升，成为总冠军最大热门。",
    content: "2025赛季NBA常规赛已过半，湖人目前以42胜18负稳居西部第一。相较于上赛季，球队防守效率提升3.2个百分点，哈姆教练调整的防守体系让浓眉更多镇守内线，詹姆斯则专注关键球处理。西部的独行侠、掘金，东部的凯尔特人都是湖人卫冕的主要障碍，但湖人的季后赛经验仍是最大优势。"
  },
  {
    id: 2,
    title: "东契奇：新一代NBA门面的成长之路",
    summary: "东契奇2025赛季场均34.2分+9.1助攻，PER值高达32.1，成为联盟新一代超级巨星。",
    content: "东契奇在2025赛季延续了巅峰状态，场均贡献34.2分、8.5篮板、9.1助攻，PER值高达32.1位列联盟第一。他的持球进攻和关键球能力已经成为独行侠的核心，也让他成为继詹姆斯之后的新一代NBA门面球员。"
  },
  {
    id: 3,
    title: "詹姆斯：没人想要连败，保持健康才是关键",
    summary: "显而易见的，不会有人想要经历连败，詹姆斯在赛后说道",
    content: "“在这个联盟里最重要的事情绝对是保持健康，希望我们的球队可以尽快摆脱伤病困扰,在常规赛取下更多胜利，在季后赛取得比上赛季更好的成绩”"
  },
  {
    id: 4,
    title: "库里28+10+6 布克38+5 勇士主场复仇太阳",
    summary: "北京时间12月21日，NBA常规赛，勇士主场对阵太阳。",
    content: "太阳最多领先14分，格林次节被驱逐，勇士下半场反超比分，关键时刻吉莱斯皮3分追至1分，库里上篮杀死比赛，勇士119-116复仇太阳",
  }
];